"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.endpoints = void 0;
var userEndpoint = "/api/user";
var endpoint = "/api/users";
var challengesEndpoint = "/api/challenges";
exports.endpoints = {
    getUserProfile: function (id) { return "".concat(userEndpoint, "/").concat(id, "/profile"); },
    getUserListByRole: "".concat(endpoint, "/list"),
    searchProviderUsersByRole: function (providerId, roleName) {
        return "".concat(endpoint, "/").concat(providerId, "/").concat(roleName);
    },
    masterLoginGetUserAvailableRoles: function (providerId) {
        return "".concat(endpoint, "/").concat(providerId, "/master-admin-login-available-roles");
    },
    getUserAvailableRoles: function (id) {
        return "".concat(endpoint, "/").concat(id, "/user-available-roles");
    },
    activateUser: function (id) { return "".concat(endpoint, "/").concat(id, "/activate"); },
    deactivateUser: function (id) { return "".concat(endpoint, "/").concat(id, "/deactivate"); },
    searchUsers: "".concat(userEndpoint, "/search"),
    blockUser: function (id) { return "".concat(endpoint, "/").concat(id, "/block"); },
    unblockUser: function (id) { return "".concat(endpoint, "/").concat(id, "/unblock"); },
    updateUser: function (id) { return "".concat(userEndpoint, "/").concat(id); },
    searchUsersThatCanCompleteStep: function (challengeId, stepId) {
        return "".concat(challengesEndpoint, "/").concat(challengeId, "/validation/").concat(stepId, "/users-to-complete-on-behalf");
    },
};
